import { createSlice } from '@reduxjs/toolkit';
import countries from './countries';
import states from './states';

const interests = [
  'Internal Regulations',
  'External Regulatory Requirement',
  'Cost Savings',
  'Trader Evaluation Tool',
  'Independent Pricing Analysis',
];

const form = {
  title: '',
  firstName: '',
  middleName: '',
  lastName: '',
  currentCustomer: null,
  companyName: '',
  email: '',
  phoneNumber: '',
  country: '',
  interests: [],
  comments: '',
};

export const accountSlice = createSlice({
  name: 'account',
  initialState: {
    countries: countries,
    states: states,
    interests: interests,
    form: form,
    validation: {},
    status: null,
    error: null,
  },
  reducers: {
    update: (state, action) => ({ ...state, ...action.payload, error: null }),
    status: (state, action) => ({
      ...state,
      status: action.payload,
      error: null,
    }),
    fill: (state, action) => ({
      ...state,
      form: { ...state.form, ...action.payload },
      error: null,
    }),
    clear: (state, action) => ({
      ...state,
      ...action.payload,
      status: null,
      form: { ...form },
      error: null,
    }),
    validation: (state, action) => ({
      ...state,
      ...action.payload,
      error: null,
    }),
    success: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    error: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export default accountSlice.reducer;
